var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 24,
    height: 24,
    id: "telegram",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fafafa",
    d: "M24,46A22,22,0,1,1,46,24,22,22,0,0,1,24,46ZM24,3.79A20.21,20.21,0,1,0,44.21,24,20.23,20.23,0,0,0,24,3.79Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fafafa",
    d: "M9.26,23.21,27,15.92c1.75-.76,7.67-3.19,7.67-3.19s2.74-1.06,2.51,1.52c-.08,1.06-.68,4.78-1.29,8.81L33.94,35S33.79,36.73,32.5,37,29.08,36,28.7,35.66,23,32,21,30.35a1.44,1.44,0,0,1,.08-2.43c2.73-2.51,6-5.62,8-7.6.91-.91,1.82-3-2-.45L16.4,27.08a4.49,4.49,0,0,1-3.5.08C10.63,26.47,8,25.56,8,25.56s-1.82-1.14,1.29-2.35Zm0,0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.497066d29bbce699207bb3a00ff707d4.svg";
export { ForwardRef as ReactComponent };